import React, { useState } from 'react';
import reiMakeItUp from '../assets/Q7/rei_makeItUp.jpg';
import hansumHeart from '../assets/Q7/hansum_heart.png';

function Q7({ question = 7, totalQuestions = null, onNavigate }) {
  const questionDisplay = totalQuestions != null ? `${question}/${totalQuestions}` : String(question);
  const [stepped, setStepped] = useState(false);

  const handleClick = () => {
    if (stepped) {
      onNavigate?.('q8');
    } else {
      setStepped(true);
    }
  };

  return (
    <div className="dashboard">
    <header className="dashboard__header">
      <div>
        <span className="dashboard__label">Title I am</span>
        <h1>Project Valen</h1>
        <p>Trust the process</p>
      </div>
      <div className="dashboard__stats home__stats">
        <div className="dashboard__stat">
          <span className="dashboard__stat-label">Challenge</span>
          <span className="dashboard__stat-value">{questionDisplay} / ?</span>
        </div>
      </div>
    </header>
    <div className="home__center q2__center q7__center">
      <span className="secretpin__title q2__greeting q7__greeting">
        {stepped ? 'Well, here goes' : <>Remember these <br/> words?</>}
      </span>
      <button
        type="button"
        className="dashboard__button dashboard__button--primary home__button q2__wave-button q7__button"
        onClick={handleClick}
      >
        {stepped ? '* Yearns for plot development *' : 'Yeah... :3'}
      </button>
      <img src={stepped ? hansumHeart : reiMakeItUp} alt="" className={`q2__gif q7__gif ${stepped ? 'q7__gif--hansum' : ''}`} />
    </div>
  </div>
  );
}

export default Q7;
